import { useQuery } from '@tanstack/react-query';
import { propBotStatsService } from '@/services/admin/prop-bot-stats-service';

export const usePropBotStats = () => {
  return useQuery({
    queryKey: ['prop-bot-stats'],
    queryFn: () => propBotStatsService.getPropBotStats(),
    refetchInterval: 30000, // Refresh every 30 seconds
    staleTime: 10000, // Consider data stale after 10 seconds
  });
};